import convertToAbsoluteAmountValue from 'components/helpers/convertToAbsoluteAmountValue'
import getRefundAmount from "components/orders/helpers/getRefundAmount"
import getTotalRefunded from "components/orders/helpers/getTotalRefunded"

export default function getRemainingRefundAmount(order) {
  return convertToAbsoluteAmountValue(getRefundAmount(order)) - convertToAbsoluteAmountValue(getTotalRefunded(order))
}